import React, { useState } from "react";
import yaml from "js-yaml";

import {
  TextField,
  Checkbox,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  FormControl,
  FormLabel,
  FormGroup,
  Container,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const jobTitles = [
  "Software Engineer",
  "Technical Program Manager",
  "Senior Software Engineer",
  "Site Reliability Engineer",
  "Quality Assurance Engineer",
  "Software Test Engineer",
  "Software Engineer Intern",
  "Data Engineer",
  "Senior Product Manager",
  "Senior Developer",
  "Automation Engineer",
  "Linux Engineer",
  "Front End Developer",
  "Account Executive",
  "Relationship Manager",
  "Account Manager",
  "Enterprise Account Executive",
  "Account Director",
  "Enterprise Account Manager",
  "Marketing Manager",
  "Marketing Specialist",
  "Campaign Manager",
  "Senior Marketing Manager",
  "Senior Digital Marketer",
  "Brand Manager",
  "Manager",
  "Consultant",
  "Solutions Manager",
  "Operations Manager",
  "Site Manager",
  "Management Trainee",
  "Event Manager",
  "Site Lead",
  "Contract Manager",
  "Deployment Manager",
  "Learning and Development Manager",
  "Senior Manager",
  "Vice President of Business Development",
  "Business Development Manager",
  "Facilities Manager",
  "Director of Engineering",
  "Vice President",
  "Sourcing Manager",
  "Senior Operation Manager",
  "Business Intelligence Manager",
  "Team Leader",
  "Recruiter",
  "Technical Recruiter",
  "Recruiting Coordinator",
  "Recruitment Resourcer",
  "Senior Compensation Analyst",
  "Director of Security",
  "Human Resources Specialist",
  "Regional Recruiter",
  "Safety Specialist",
  "Sourcing Specialist",
  "Senior Technical Recruiter",
  "Receptionist",
  "Operations Associate",
  "Billing Specialist",
  "Office Administrator",
  "Center Manager",
  "Executive Assistant",
  "Student Assistant",
  "Government Executive",
  "Operations Intern",
  "Administrative Assistant",
  "Assistant Secretary",
  "Project Intern",
  "Personal Assistant",
  "Systems Analyst",
  "Data Analyst",
  "Operations Analyst",
  "Technology Analyst",
  "Technical Consultant",
  "User Experience Designer",
  "Customer Insights Analyst",
  "Senior Business Process Analyst",
  "Instructional Designer",
  "Senior User Experience Designer",
  "Business Analyst",
  "Support Specialist",
  "Customer Service Manager",
  "Customer Success Manager",
  "Senior Customer Service Representative",
  "Customer Specialist",
  "Customer Service Representative",
  "Support Associate",
  "Customer Support Representative",
  "Program Manager",
  "Project Manager",
  "Strategic Project Manager",
  "Project Manager/Business Analyst",
  "Project Coordinator",
  "Analyst",
  "Senior Data Scientist",
  "Senior Analyst",
  "Data Science Intern",
  "Technician",
  "Operator",
  "Equipment Technician",
  "Editor",
  "Audio Visual Engineer",
  "Communications Associate",
  "Video Editor",
  "Writer/Editor",
  "Freelance Writer",
  "Accounts Payable Clerk",
  "Senior Billing Analyst",
  "Director of Financial Planning and Analysis",
  "Finance Manager",
  "Accountant",
  "Billing Analyst",
  "Procurement Analyst",
  "Senior Quality Specialist",
  "Production Manager",
  "Security Officer",
  "Test Engineer",
  "Senior System Engineer",
  "Senior Engineering Manager",
  "System Engineer",
  "Trainer",
  "Training Coordinator",
  "Director of Admissions",
  "Training Developer",
  "Dance Instructor",
  "Server",
  "Barista",
  "Cook",
  "IT Support",
  "Data Center Technician",
  "Senior Network Engineer",
  "Helpdesk Technician",
  "Life Science Consultant",
  "Laboratory Supervisor",
  "Content Strategist",
  "Cinematographer",
  "Social Worker",
  "Wellness Coordinator",
  "Mentor",
  "Quarry Manager",
  "Hardware Engineer",
  "Independent Contractor",
  "Lawyer",
  "Compliance Officer",
  "Behavior Technician",
  "Logistic Coordinator",
  "Equipment Operator",
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));
const names = [
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Aruba",
  "Australia",
  "Austria",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Indian Ocean Territory",
  "British Virgin Islands",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Canada",
  "Canary Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Cook Islands",
  "Costa Rica",
  "Côte d'Ivoire",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern and Antarctic Lands",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Gibraltar",
  "Greece",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Authority",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthélemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
function UserForm() {
  const [remote, setRemote] = useState(false);
  const [experienceLevel, setExperienceLevel] = useState({
    internship: false,
    entry: false,
    associate: false,
    "mid-senior level": false,
    director: false,
    executive: false,
  });
  const [jobTypes, setJobTypes] = useState({
    fullTime: false,
    contract: false,
    partTime: false,
    temporary: false,
    internshipType: false,
    other: false,
    volunteer: false,
  });
  const [date, setDateTypes] = useState({
    allTime: true,
    Month: false,
    Week: false,
    Hours24: false,
  });
  const [positions, setPositions] = useState("");
  const [locations, setLocations] = useState("");
  const [distance, setDistance] = useState(100);
  const [companyBlacklist, setCompanyBlacklist] = useState("");
  const [titleBlacklist, setTitleBlacklist] = useState("");
  const [personName, setPersonName] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      remote,
      experienceLevel,
      jobTypes,
      date,
      positions,
      locations,
      distance,
      companyBlacklist,
      titleBlacklist,
    };
    const inputData = formData;
    // Handle form submission
    const yamlData = {
      remote: inputData.remote,
      experienceLevel: {
        internship: inputData.experienceLevel.internship,
        entry: inputData.experienceLevel.entry,
        associate: inputData.experienceLevel.associate,
        "mid-senior level": inputData.experienceLevel["mid-senior level"],
        director: inputData.experienceLevel.director,
        executive: inputData.experienceLevel.executive,
      },
      jobTypes: {
        "full-time": inputData.jobTypes["fullTime"],
        contract: inputData.jobTypes.contract,
        "part-time": false,
        temporary: inputData.jobTypes.temporary,
        internship: inputData.jobTypes.internshipType,
        other: inputData.jobTypes.other,
        volunteer: inputData.jobTypes.volunteer,
      },
      date: {
        "all time": inputData.date["allTime"],
        month: inputData.date.Month,
        week: inputData.date.Week,
        "24 hours": inputData.date["Hours24"],
      },
      positions: inputData.positions
        .trim()
        .split("\n")
        .map((item) => item.trim()),
      locations: inputData.locations
        .trim()
        .split("\n")
        .map((item) => item.trim()),
      distance: inputData.distance,
      companyBlacklist: inputData.companyBlacklist
        .trim()
        .split("\n")
        .map((item) => item.trim()),
      titleBlacklist: inputData.titleBlacklist
        .trim()
        .split("\n")
        .map((item) => item.trim()),
    };

    //console.log(jsyaml.dump(yamlData));

    const yamlDataObj = yaml.dump(yamlData);
    const blob = new Blob([yamlDataObj], { type: "text/yaml" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "config.yaml";
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    setLocations(
      typeof value === "string" ? value.split(",").join("\n") : value.join("\n")
    );
  };
  return (
    <Box   sx={{ p: 3, pt: 0, pb: 2,mt:3 }}>
      <form onSubmit={handleSubmit}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Item>
                {" "}
                <FormControl component="fieldset">
                  <FormLabel component="legend" variant="h6">
                    Remote
                  </FormLabel>
                  <RadioGroup
                    row
                    value={remote.toString()}
                    onChange={(e) => setRemote(e.target.value === "true")}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label="True"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label="False"
                    />
                  </RadioGroup>
                </FormControl>
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Experience Level</FormLabel>
                  <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                    {Object.entries(experienceLevel).map(([key, value]) => (
                      <FormControlLabel
                        sx={{ textTransform: "capitalize" }}
                        key={key}
                        control={
                          <Checkbox
                            checked={value}
                            onChange={(e) =>
                              setExperienceLevel({
                                ...experienceLevel,
                                [key]: e.target.checked,
                              })
                            }
                          />
                        }
                        label={key}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>
                {" "}
                <FormControl component="fieldset">
                  <FormLabel component="legend">Job Types</FormLabel>
                  <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                    {Object.entries(jobTypes).map(([key, value]) => (
                      <FormControlLabel
                        key={key}
                        sx={{ textTransform: "capitalize" }}
                        control={
                          <Checkbox
                            checked={value}
                            onChange={(e) =>
                              setJobTypes({
                                ...jobTypes,
                                [key]: e.target.checked,
                              })
                            }
                          />
                        }
                        label={key}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Date</FormLabel>
                  <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                    {Object.entries(date).map(([key, value]) => (
                      <FormControlLabel
                        key={key}
                        sx={{ textTransform: "capitalize" }}
                        control={
                          <Radio
                            checked={value}
                            onChange={(e) => {
                              const updatedDateTypes = { ...date };
                              for (const dateType in updatedDateTypes) {
                                if (dateType === key) {
                                  updatedDateTypes[dateType] = true;
                                } else {
                                  updatedDateTypes[dateType] = false;
                                }
                              }
                              setDateTypes(updatedDateTypes);
                            }}
                          />
                        }
                        label={key === "Hours24" ? "24 Hours" : key}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>
                <TextField
                  label="Distance"
                  type="number"
                  fullWidth
                  value={distance}
                  onChange={(e) => setDistance(e.target.value)}
                  helperText="* Please set the radius for your job search in miles"
                />
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>
                <TextField
                  label="Locations"
                  placeholder={"Hong Kong \nPakistan"}
                  sx={{ whiteSpace: "pre-line", display: "none" }}
                  multiline
                  rows={4}
                  required
                  value={locations}
                  onChange={(e) => setLocations(e.target.value)}
                  helperText="* Please list locations you want to search in, one per line"
                />
                <FormControl sx={{ m: 1, width: 500 }}>
                  <InputLabel id="demo-multiple-checkbox-label">
                    Locations
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    fullWidth
                    required
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Tag" />}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={MenuProps}
                  >
                    {names.map((name) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={personName.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>
                <TextField
                  label="Positions"
                  multiline
                  placeholder={
                    "Software Developer \nCybersecurity\nData Analyst"
                  }
                  rows={4}
                  fullWidth
                  value={positions}
                  onChange={(e) => setPositions(e.target.value)}
                  required
                />
                <small component="span" className="MuiFormHelperText-root">
                  {" "}
                  * Please list job titles you're interested in, one per line.
                </small>
                &nbsp;
                <small
                  onClick={handleClickOpen}
                  style={{
                    color: "#1976d2",
                    cursor: "pointer",
                    fontFamily: "Poppins",
                  }}
                >
                  See Positions
                </small>
                <Dialog
                  open={open}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={handleClose}
                  aria-describedby="alert-dialog-slide-description"
                >
                  <DialogTitle>{"Positions"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                      <ul>
                        {jobTitles.map((title, index) => (
                          <li key={index}>{title}</li>
                        ))}
                      </ul>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                  </DialogActions>
                </Dialog>
              </Item>
            </Grid>
          

            <Grid size={12}>
              <Item>
                <TextField
                  label="Company Blacklist"
                  placeholder={"Company X \nCompany Y"}
                  multiline
                  fullWidth
                  rows={4}
                  value={companyBlacklist}
                  onChange={(e) => setCompanyBlacklist(e.target.value)}
                  helperText="* Please list companies you want to exclude from your search, one per line"
                />
              </Item>
            </Grid>
            <Grid size={12}>
              <Item>
                {" "}
                <TextField
                  label="Title Blacklist"
                  placeholder={"Sales \nMarketing"}
                  multiline
                  fullWidth
                  rows={4}
                  value={titleBlacklist}
                  onChange={(e) => setTitleBlacklist(e.target.value)}
                  helperText="* Please list keywords in job titles you want to avoid, one per line"
                />
              </Item>
            </Grid>
            <Grid size={12}>
              
                <Button type="submit" variant="contained" color="primary">
                  Submit
                </Button>
        
            </Grid>
          </Grid>
        </Box>
      </form>
    </Box>
  );
}

export default UserForm;
